// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzIyMzJfMjU0OCkiPgo8cGF0aCBkPSJNMTIgNVYxOU01IDEySDE5IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzIyMzJfMjU0OCI+CjxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzIyMzJfMjU1MikiPgo8cGF0aCBkPSJNMTkgMTJMNSAxMiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8yMjMyXzI1NTIiPgo8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNCAyNCkgcm90YXRlKC0xODApIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@400;500);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Qqb8HWq9rFy8x2GCCdqX {
  padding: 7px !important;
}
.Qqb8HWq9rFy8x2GCCdqX:active {
  background-color: #5b37c0 !important;
}

.Zpk8UCLlEeCFs209E03g {
  width: 43px;
  height: 86px;
  overflow: hidden;
  border-radius: 32px;
  margin: 0;
  padding: 0;
  opacity: 1;
  visibility: visible;
}
.Zpk8UCLlEeCFs209E03g .qUjUUDsObFirwAzfa8RG {
  display: block;
  width: 100%;
  height: 50%;
  padding: 0;
  margin: 0;
  background-color: rgba(50, 50, 50, 0.8);
  outline: unset;
  border: unset;
  border-radius: unset;
  color: #fff;
  transition: all 0.3s;
}
.Zpk8UCLlEeCFs209E03g .qUjUUDsObFirwAzfa8RG.koCD1NHoRZj1gZdHtP3q {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: bottom 8px center;
}
.Zpk8UCLlEeCFs209E03g .qUjUUDsObFirwAzfa8RG.VG_KddSEYZlH01SRyFSJ {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: top 8px center;
}
.Zpk8UCLlEeCFs209E03g .qUjUUDsObFirwAzfa8RG:active {
  background-color: #5b37c0;
}`, "",{"version":3,"sources":["webpack://./src/editor/components/elements/ZoomButtons/ZoomButtons.module.scss","webpack://./src/editor/style/variables.scss"],"names":[],"mappings":"AAEA;EACE,uBAAA;AAAF;AACE;EACE,oCAAA;AACJ;;AAGA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,mBAAA;AAAF;AACE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,uCCqCU;EDpCV,cAAA;EACA,aAAA;EACA,oBAAA;EACA,WCVI;EDWJ,oBAAA;AACJ;AAAI;EACE,yDAAA;EACA,4BAAA;EACA,sCAAA;AAEN;AAAI;EACE,yDAAA;EACA,4BAAA;EACA,mCAAA;AAEN;AAAI;EACE,yBCnCO;ADqCb","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"resetZoomButton": `Qqb8HWq9rFy8x2GCCdqX`,
	"wrapper": `Zpk8UCLlEeCFs209E03g`,
	"btn": `qUjUUDsObFirwAzfa8RG`,
	"plusButton": `koCD1NHoRZj1gZdHtP3q`,
	"minusButton": `VG_KddSEYZlH01SRyFSJ`
};
export default ___CSS_LOADER_EXPORT___;
